import { Input } from 'reactstrap';

const AdminInput = (props) => {
  return props.isAdmin 
    ? <Input
        type={props.type ?? 'text'}
        autoComplete={props.autoComplete ?? 'off'}
        value={props.value}
        onChange={props.onChange}
        disabled={props.disabled}
      />
    : <span className='user-display'>{props.value}</span>
}

export default AdminInput;